import { render, staticRenderFns } from "./_ListActions.vue?vue&type=template&id=3b5d5dd2&scoped=true&"
import script from "./_ListActions.vue?vue&type=script&lang=ts&"
export * from "./_ListActions.vue?vue&type=script&lang=ts&"
import style0 from "./_ListActions.vue?vue&type=style&index=0&id=3b5d5dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d5dd2",
  null
  
)

export default component.exports